module.exports = __webpack_public_path__ + "static/media/temp_w_domu_off_1.a3fdf9d2.svg";